const INFO = {
	main: {
		title: "Soumik Saha — Software Engineer",
		name: "Soumik Saha",
		role: "Software Engineer | Full-Stack Developer",
		email: "sahasoumik1573@gmail.com",
		location: "Kolkata, India",
		company: "TCS (Tata Consultancy Services)",
		joinedCompany: "August 2025",
		url: "https://www.soumik.co.in/",
		logo: "../logo.jpg",
	},

	socials: {
		github: "https://github.com/soumik-saha",
		linkedin: "https://linkedin.com/in/soumikisonline",
		twitter: "https://x.com/soumikisonline",
		leetcode: "https://leetcode.com/u/soumiksaha/",
		geeksforgeeks: "https://www.geeksforgeeks.org/profile/soumik_saha",
		codechef: "https://www.codechef.com/users/edgeofsoumik",
	},

	homepage: {
		title: "Building software that solves real problems.",
		description:
			"Software Engineer focused on Java, Spring Boot, backend engineering, and full-stack development. I build reliable applications, solve engineering problems, and continuously explore better ways to design and scale software.",
		status: "Currently building & learning",
	},

	about: {
		title: "Software Engineer with enterprise experience & full-stack capability.",
		description:
			"I am a Software Engineer at TCS with 1+ year of professional experience building and maintaining enterprise-scale software. My primary strength lies in backend engineering with Java and Spring Boot, REST APIs, PostgreSQL, authentication/security, and performance optimization. Outside work, I build full-stack applications to deepen my understanding of software design and modern web architecture.",
	},

	metrics: [
		{
			value: "1+",
			label: "YEAR EXPERIENCE",
			subtext: "Professional Software Development",
		},
		{
			value: "500K+",
			label: "USERS SUPPORTED",
			subtext: "Enterprise HR Platform at TCS",
		},
		{
			value: "25–30%",
			label: "LATENCY REDUCTION",
			subtext: "PostgreSQL & REST API Optimization",
		},
		{
			value: "Java & Spring",
			label: "PRIMARY STACK",
			subtext: "Backend & RESTful Architecture",
		},
	],

	experience: [
		{
			company: "Tata Consultancy Services (TCS)",
			role: "Systems Engineer / Software Engineer",
			location: "Kolkata, India",
			period: "August 2025 – Present",
			type: "Full-Time",
			logo: "./tcs.jpg",
			description:
				"Working as a Full-Stack Developer on an enterprise HR and recruitment platform supporting over 500,000 active users.",
			highlights: [
				"Engineered Java + Spring Boot backend services and REST APIs for enterprise recruitment workflows.",
				"Designed & implemented OTP-based authentication and Two-Factor Authentication (2FA) security modules.",
				"Developed features for recruitment management and background-verification processing pipelines.",
				"Diagnosed production incidents and optimized PostgreSQL database queries, reducing API response latency by ~25–30%.",
				"Collaborated across enterprise code reviews, automated unit testing, and agile deployment cycles.",
			],
			tags: ["Java", "Spring Boot", "REST APIs", "PostgreSQL", "2FA", "Query Optimization"],
		},
		{
			company: "Accenture",
			role: "Associate Software Engineer Intern",
			location: "Kolkata, India",
			period: "Feb 2025 – Jun 2025",
			type: "Internship",
			logo: "./accenture.png",
			description:
				"Worked on web application components and enterprise software integrations.",
			highlights: [
				"Developed full-stack web modules using modern JavaScript frameworks and API endpoints.",
				"Participated in software requirement analysis, unit testing, and bug fixing.",
			],
			tags: ["JavaScript", "React", "Node.js", "Web APIs"],
		},
		{
			company: "Infosys",
			role: "Java Developer Intern",
			location: "Remote",
			period: "May 2024 – Jul 2024",
			type: "Internship",
			logo: "./infosys.png",
			description:
				"Developed and maintained Java-based backend components and services.",
			highlights: [
				"Constructed object-oriented backend modules following clean architecture principles.",
				"Implemented database integration and CRUD service layers for web application modules.",
			],
			tags: ["Java", "OOP", "MySQL", "Backend"],
		},
	],

	projects: [
		{
			id: "skyfleet",
			title: "SkyFleet",
			subtitle: "Flight Booking Platform",
			problem: "Complex flight search, inventory management, and multi-step transactional checkout require strict backend validation.",
			description:
				"Full-stack flight booking application featuring multi-city search, user authentication, interactive seat mapping, Razorpay payment processing, and transaction management.",
			tech: ["React", "Vite", "Java", "Spring Boot", "PostgreSQL", "Razorpay"],
			featured: true,
			architecture: [
				{ step: "Client", label: "React + Vite SPA UI" },
				{ step: "API Layer", label: "Spring Boot REST Controller" },
				{ step: "Core Logic", label: "Flight & Booking Service" },
				{ step: "Database", label: "PostgreSQL Relational Storage" },
				{ step: "Payment Gateway", label: "Razorpay Secure API" },
			],
			highlights: [
				"Implemented transactional booking workflows with ACID database guarantees.",
				"Designed REST APIs for flight search, availability verification, and seat allocation.",
				"Integrated Razorpay webhook callbacks for secure payment verification.",
			],
			githubLink: "https://github.com/soumik-saha/skyfleet",
			link: "https://github.com/soumik-saha/skyfleet",
			linkText: "View Repository",
		},
		{
			id: "pulseconnect",
			title: "PulseConnect",
			subtitle: "Real-Time Communication Platform",
			problem: "Low-latency bidirectional messaging requires scalable event handlers and clean state synchronization.",
			description:
				"Real-time healthcare messaging and communication application connecting providers with patients, streamlining appointment scheduling and instant messaging. Winner of 30DC Hackathon Challenge.",
			tech: ["MongoDB", "Express.js", "React", "Node.js", "Socket.io"],
			featured: true,
			highlights: [
				"Built WebSocket real-time messaging pipeline for instant chat dispatch.",
				"Implemented JWT session authentication and role-based access control.",
				"Optimized MongoDB document schemas for rapid chat history retrieval.",
			],
			githubLink: "https://github.com/soumik-saha/pulseconnect",
			link: "https://github.com/soumik-saha/pulseconnect",
			linkText: "View Repository",
		},
		{
			id: "skypulse",
			title: "SkyPulse",
			subtitle: "Automated Aircraft Damage Inspection System",
			problem: "Manual aircraft wire & hull inspection is time-consuming and error-prone.",
			description:
				"Developed for AIRBUS AEROTHON 6.0 (Finale Shortlist). Automates aircraft wire fault identification and damage assessment using computer vision models.",
			tech: ["Python", "OpenCV", "YOLOv5", "Random Forest", "Streamlit"],
			featured: false,
			highlights: [
				"Trained YOLOv5 computer vision model for identifying wiring anomalies in high-resolution images.",
				"Built interactive Streamlit web dashboard for engineers to inspect repair recommendations.",
			],
			githubLink: "https://github.com/soumik-saha/SkyPulse",
			link: "https://github.com/soumik-saha/SkyPulse",
			linkText: "View Repository",
		},
		{
			id: "learnhub",
			title: "LearnHub",
			subtitle: "Course Enrollment & Learning Portal",
			problem: "Educational portals need structured catalog management and student progress tracking.",
			description:
				"MERN stack web application providing interactive course catalogs, student registration, instructor content creation, and course enrollment.",
			tech: ["React.js", "Node.js", "Express.js", "MongoDB"],
			featured: false,
			highlights: [
				"Designed REST API endpoints for course publishing and student enrollment.",
				"Created clean responsive frontend dashboard with React state management.",
			],
			githubLink: "https://github.com/soumik-saha/LearnHub",
			link: "https://github.com/soumik-saha/LearnHub",
			linkText: "View Repository",
		},
		{
			id: "elitetask",
			title: "EliteTask Dynamics",
			subtitle: "Team Task Management System",
			problem: "Team collaboration suffers without intuitive task prioritization and progress visibility.",
			description:
				"Task tracking platform designed for teams and individuals to assign tasks, set priority statuses, monitor timelines, and track completion metrics.",
			tech: ["JavaScript", "HTML5", "CSS3", "Express", "Node.js"],
			featured: false,
			highlights: [
				"Built intuitive task drag-and-drop status boards.",
				"Engineered lightweight REST backend for task state persistence.",
			],
			githubLink: "https://github.com/soumik-saha/elitetask-dynamics",
			link: "https://github.com/soumik-saha/elitetask-dynamics",
			linkText: "View Repository",
		},
		{
			id: "bookstore",
			title: "Book Store Automation",
			subtitle: "Inventory & Order Management System",
			problem: "Manual inventory tracking leads to stock discrepancies and delayed order processing.",
			description:
				"Full-stack bookstore management app simplifying book inventory tracking, customer orders, and catalog browsing using the MERN stack.",
			tech: ["React.js", "Node.js", "Express.js", "MongoDB"],
			featured: false,
			highlights: [
				"Implemented full CRUD inventory management for administrators.",
				"Integrated frontend search and filtering by author, genre, and price.",
			],
			githubLink: "https://github.com/soumik-saha/Book-Store",
			link: "https://github.com/soumik-saha/Book-Store",
			linkText: "View Repository",
		},
	],

	skills: [
		{
			category: "Languages",
			items: [
				{ name: "Java", level: "Primary", icon: "code" },
				{ name: "Python", level: "Proficient", icon: "code" },
				{ name: "JavaScript (ES6+)", level: "Proficient", icon: "code" },
				{ name: "SQL", level: "Proficient", icon: "database" },
				{ name: "C++", level: "Core", icon: "code" },
			],
		},
		{
			category: "Backend",
			items: [
				{ name: "Spring Boot", level: "Primary", icon: "server" },
				{ name: "REST APIs", level: "Primary", icon: "cpu" },
				{ name: "Spring Security", level: "Proficient", icon: "lock" },
				{ name: "JPA / Hibernate", level: "Proficient", icon: "layers" },
				{ name: "Microservices", level: "Fundamentals", icon: "grid" },
				{ name: "Node.js & Express", level: "Proficient", icon: "server" },
			],
		},
		{
			category: "Frontend",
			items: [
				{ name: "React", level: "Proficient", icon: "layout" },
				{ name: "Redux", level: "Core", icon: "box" },
				{ name: "Vite", level: "Proficient", icon: "zap" },
				{ name: "HTML5 / CSS3", level: "Proficient", icon: "code" },
			],
		},
		{
			category: "Databases",
			items: [
				{ name: "PostgreSQL", level: "Primary", icon: "database" },
				{ name: "MongoDB", level: "Proficient", icon: "database" },
				{ name: "MySQL", level: "Proficient", icon: "database" },
				{ name: "Redis", level: "Learning", icon: "cpu" },
			],
		},
		{
			category: "Cloud / DevOps",
			items: [
				{ name: "AWS", level: "Fundamentals", icon: "cloud" },
				{ name: "Docker", level: "Fundamentals", icon: "box" },
				{ name: "Git & GitHub", level: "Proficient", icon: "git-branch" },
				{ name: "Postman", level: "Proficient", icon: "terminal" },
				{ name: "Linux", level: "Core", icon: "terminal" },
			],
		},
		{
			category: "AI & GenAI",
			items: [
				{ name: "Generative AI", level: "Exploring", icon: "sparkles" },
				{ name: "LLM Apps", level: "Exploring", icon: "cpu" },
				{ name: "LangChain", level: "Fundamentals", icon: "link" },
				{ name: "Hugging Face", level: "Exploring", icon: "box" },
				{ name: "AI-Assisted Dev", level: "Proficient", icon: "zap" },
			],
		},
		{
			category: "Engineering",
			items: [
				{ name: "Data Structures (DSA)", level: "Strong", icon: "terminal" },
				{ name: "Object-Oriented (OOP)", level: "Strong", icon: "layers" },
				{ name: "System Design", level: "Growing", icon: "cpu" },
				{ name: "Database Design", level: "Proficient", icon: "database" },
				{ name: "API Design", level: "Proficient", icon: "globe" },
			],
		},
	],

	learning: [
		{
			title: "System Design",
			description: "Designing scalable, fault-tolerant distributed services, load balancing, and data partition strategies.",
			icon: "cpu",
		},
		{
			title: "Cloud Architecture",
			description: "AWS cloud primitives, IAM, ECS, Lambda serverless, and cloud infrastructure best practices.",
			icon: "cloud",
		},
		{
			title: "Distributed Systems",
			description: "Caching mechanisms with Redis, message streaming via Kafka, data consistency, and microservice communication.",
			icon: "network",
		},
		{
			title: "Generative AI",
			description: "Integrating Large Language Models into software workflows, RAG systems, and AI agent frameworks.",
			icon: "sparkles",
		},
		{
			title: "DevOps & Containers",
			description: "Container orchestration with Docker & Kubernetes, CI/CD pipelines, and application observability.",
			icon: "box",
		},
	],

	journey: [
		{
			year: "2024",
			title: "Foundation & Internships",
			description: "Focused on Data Structures & Algorithms, Java OOP, full-stack MERN apps, and completed developer internships at Infosys and Accenture.",
		},
		{
			year: "2025",
			title: "Joined TCS (Systems Engineer)",
			description: "Started full-time enterprise software engineering on TCS's HR recruitment platform for 500K+ users. Built Spring Boot APIs & optimized DB performance.",
		},
		{
			year: "2026",
			title: "Enterprise Depth",
			description: "Deepening Java backend expertise, PostgreSQL query optimization (~25-30% latency reduction), authentication (2FA/OTP), and production troubleshooting.",
		},
		{
			year: "NOW",
			title: "System Design + Cloud + AI",
			description: "Actively mastering distributed system patterns, AWS cloud development, and AI-assisted application building.",
		},
		{
			year: "NEXT",
			title: "Product & Scalable Engineering",
			description: "Aiming to design high-throughput backend services and lead end-to-end product features that impact millions of users.",
		},
	],

	achievements: [
		"Global Rank 1560 in TCS CODEVITA Season 11 Round 1 (out of 136,054 participants) and 1387 in Round 2.",
		"Winner of 30DC Hackathon Challenge with PulseConnect.",
		"Finalist / Shortlisted in AIRBUS AEROTHON 6.0 with SkyPulse.",
		"Peak Rating 1813 on LeetCode (Top 7.15% globally).",
		"3-Star Coder on CodeChef (Max rating 1609).",
		"Secured 1st Position in 'League of Errors' coding competition by Coding Ninjas.",
		"Solved 2,000+ problems across competitive coding platforms (LeetCode, GFG, CodeChef).",
	],

	articles: {
		title: "Engineering insights & technical writing.",
		description:
			"Thoughts on backend engineering, system architecture, database optimization, and modern software development practices.",
	},
};

export default INFO;
